import {Html5Qrcode} from "html5-qrcode";

export default class QRCodeReader {
  constructor() {
    this.started = false;
    this.qrcode = new Html5Qrcode("reader");
  }

  async checkCameraPermissions() {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const cameras = devices.filter(device => device.kind === "videoinput");
    return cameras.some(camera => camera.deviceId !== "");
  }

  async start(onStartSuccessCallback = () => {}, onErrorCallback) {
    try {
      const devices = await Html5Qrcode.getCameras();
      if (devices && devices.length) {
        await this.doStart(onStartSuccessCallback, onErrorCallback);
      }
    } catch (e) {
      const error = new Error(
        "Error getting access to the camera. Please check if your browser has access to the camera. If not, allow it."
      );
      error.code = "failed_to_get_camera";
      onErrorCallback(error);

      throw e;
    }
  }

  async doStart(onStartSuccessCallback, onErrorCallback) {
    try {
      const ua = navigator.userAgent.toLowerCase();
      const isAndroid = ua.indexOf("android") > -1;

      const ar =
        window.innerHeight > window.innerWidth
          ? window.innerHeight / window.innerWidth
          : window.innerWidth / window.innerHeight;
      await this.qrcode.start(
        {facingMode: "environment"},
        {
          fps: 10,
          qrbox: {width: 250, height: 250},
          videoConstraints: {
            aspectRatio: ar,
            width: isAndroid ? window.innerHeight : window.innerWidth,
            height: isAndroid ? window.innerWidth : window.innerHeight,
            facingMode: "environment",
          },
        },
        onStartSuccessCallback
      );
      this.started = true;
    } catch (err) {
      const error = new Error(`Couldn't start the QR Code Reader. Error: ${err}`);
      error.code = "failed_to_start_reader";
      onErrorCallback(error);
    }
  }

  async stop() {
    await this.qrcode.stop();
    this.started = false;
  }
}
